import { Action, createReducer, on } from "@ngrx/store";
import { SchedulerState, SCHEDULER_INIT_STATE } from "./scheduler.state";
import * as schedulerActions from "./scheduler.action";

const _schedulerReducer = createReducer(

    SCHEDULER_INIT_STATE,

    on(
        schedulerActions.addTask,
        (state, action) => {
            const tasks = state.tasks;
            const tasksByType = tasks[action.taskType] ? tasks[action.taskType].slice() : [];
            tasksByType.push(action.task);
            tasks[action.taskType] = tasksByType
            return {
                ...state,
                tasks,
            }
        }
    ),

    on(
        schedulerActions.addTasks,
        (state, action) => {
            const tasks = state.tasks;
            const tasksByType = tasks[action.taskType] ? tasks[action.taskType].slice() : [];
            tasksByType.push(...action.tasks);
            tasks[action.taskType] = tasksByType
            return {
                ...state,
                tasks,
            }
        }
    ),

    on(
        schedulerActions.executeTaskFinished,
        (state, action) => {
            const tasks = state.tasks;
            tasks[action.taskType] = tasks[action.taskType].slice(1);
            return {
                ...state,
                tasks,
            }
        }
    ),

    on(
        schedulerActions.startRunnig,
        (state, action) => {
            const tasksRunning = state.tasksRunning;
            tasksRunning[action.taskType] = true;
            return {
                ...state,
                tasksRunning
            }
        }
    ),

    on(
        schedulerActions.stopRunnig,
        (state, action) => {
            const tasksRunning = state.tasksRunning;
            tasksRunning[action.taskType] = false;
            return {
                ...state,
                tasksRunning
            }
        }
    ),
);

export function schedulerReducer(state: SchedulerState, action: Action) {
    return _schedulerReducer(state, action);
}